import { Theme } from '@material-ui/core';
import React, { FC } from 'react';
import { createGlobalStyle } from 'styled-components';

import { CircularXXWebBold, CircularXXWebBook, CircularXXWebMedium } from 'src/styles/fonts';

const Style = createGlobalStyle`
  @font-face {
    font-family: "CircularXXWeb-Bold";
    src: url(${CircularXXWebBold}) format("woff");
  }

  @font-face {
    font-family: "CircularXXWeb-Book";
    src: url(${CircularXXWebBook}) format("woff");
  }

  @font-face {
    font-family: "CircularXXWeb-Medium";
    src: url(${CircularXXWebMedium}) format("woff");
  }

  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }

  body.fontLoaded {
    font-family: ${({ theme }) => `'Lato', ${theme.typography.fontFamily}`};
  }
`;

export interface GlobalStyleProps {
  theme: Theme;
}

export const GlobalStyle: FC<GlobalStyleProps> = ({ ...props }) => <Style {...props} />;
